import React from "react";
import { useParams } from "react-router-dom";
import MainLayout from "core/components/layout/MainLayout";
import Loading from "core/components/Loading";
import Error from "core/components/Error";
import TimeAgoWidget from "core/components/shared/TimeAgoWidget";
import BreadcrumbWidget from "core/components/shared/BreadcrumbWidget";
import useReport from "../hooks/useReport";
import ReactMarkdown from "react-markdown";
import { JsonTable, isJsonArray,cleanJsonString, JsonStructure } from "../components/JsonTable";
import ReportUseCases from "../components/ReportUseCases";
import MetadataViewWidget from "../components/MetadataViewWidget";
import rehypeRaw from 'rehype-raw'

const ReportDetailsPage: React.FC = () => {
  const { reportId } = useParams<{ reportId: string }>();
  
  const { data: report, isLoading, error } = useReport(reportId);


  if (isLoading) return <Loading isLoading={isLoading} />;
  if (error) return <Error error={error + ""} />;
  if (!report) return <Error error="Report not found" />;

  const renderContent = () => {
    if (isJsonArray(report.generated_report)) {
      const jsonData = JSON.parse(cleanJsonString(report.generated_report));
      let structure: JsonStructure | undefined;

      // Check if prompt has json_structure
      if (report.prompt?.json_structure) {
        try {
          structure = JSON.parse(report.prompt.json_structure);
        } catch (e) {
          console.error('Failed to parse json_structure:', e);
        }
      }

      return <JsonTable data={jsonData} structure={structure} />;
    }
    return <ReactMarkdown rehypePlugins={[rehypeRaw]}>{report.generated_report}</ReactMarkdown>;
  };

  return (
    <MainLayout>
      <div className="container">
        <BreadcrumbWidget
          mainTitle={report.topic}
          titleClassName="query-title"
          breadcrumbs={[
            { title: "Dashboard", url: "/" },
            { title: "Reports", url: "/reports" },
            { title: "Details" },
          ]}
        />

        <div className="row">
          <div className="col-xl-12">
            <div className="card custom-card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <div>
                  {/* <h2 className="fs-22 fw-semibold mb-3">{report.topic}</h2> */}
                  {/* <div className="text-muted">
                    Generated from query: {report.query}
                  </div> */}
                  <div className="text-muted">
                    <TimeAgoWidget date={report.created_at} />
                  </div>
                </div>
              </div>
              
              
              <div className="card-body">
                {report.generated_report && (
                  <div className="markdown-content">
                    {renderContent()}
                  </div>
                )}


                <ReportUseCases report={report} />



                {report.metadata?.research_summary && (
                  <div className="accordion mb-4" id="researchSummaryAccordion">
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingResearchSummary">
                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseResearchSummary" aria-expanded="false" aria-controls="collapseResearchSummary">
                          Research Summary
                        </button>
                      </h2>
                      <div id="collapseResearchSummary" className="accordion-collapse collapse" aria-labelledby="headingResearchSummary" data-bs-parent="#researchSummaryAccordion">
                        <div className="accordion-body">
                          <ReactMarkdown>{report.metadata.research_summary}</ReactMarkdown>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                

                
                <div className="accordion" id="thoughtsAccordion">
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingThoughts">
                      <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThoughts" aria-expanded="false" aria-controls="collapseThoughts">
                        Thoughts
                      </button>
                    </h2>
                    <div id="collapseThoughts" className="accordion-collapse collapse " aria-labelledby="headingThoughts" data-bs-parent="#thoughtsAccordion">
                      <div className="accordion-body">


                        

                        {/* {report.metadata && (
                          <div className="metadata-section mb-4">
                            <p>Metadata</p>
                            <MetadataViewWidget data={report.metadata} />
                          </div>
                        )} */}


                        {report.metadata?.search_queries && report.metadata.search_queries.length > 0 && (
                          <div className="search-queries-section mb-4">
                            <p>Search Queries</p>
                            <ul className="list-group">
                              {report.metadata.search_queries.map((query: string, index: number) => (
                                <li key={index} className="list-group-item">{query}</li>
                              ))}
                            </ul>
                          </div>
                        )}
                        <div className="markdown-content">
                          {Array.isArray(report.thoughts) ? (
                            <ReactMarkdown>{report.thoughts.join("")}</ReactMarkdown>
                          ) : (
                            <ReactMarkdown>{report.thoughts}</ReactMarkdown>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default ReportDetailsPage;
